import React from "react";
import { Chip, Skeleton, Stack, Typography } from "@mui/material";

// DEV-1666 - Status Last Order Pengkinian dari Lavender profile-customer (`pengkinian`: "YES" | "NO" | null).
// null = gagal dihitung / BE lama belum kirim field -> "-", bukan NO, supaya Sales tidak salah menyimpulkan.
export const PENGKINIAN_LOADING = "loading";

export function resolvePengkinianStatus(pengkinian) {
    return pengkinian === "YES" || pengkinian === "NO" ? pengkinian : null;
}

export default function PengkinianStatus({ status }) {
    return (
        <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between" sx={{mb: 1.5}} data-testid="pengkinian-status">
            <Typography variant="body2" color="text.secondary">Last Order Pengkinian</Typography>
            {
                status === PENGKINIAN_LOADING ? (
                    <Skeleton variant="rounded" width={40} height={24} data-testid="pengkinian-loading" />
                ) : status === "YES" || status === "NO" ? (
                    <Chip
                        size="small"
                        label={status}
                        color={status === "YES" ? "success" : "error"}
                        data-testid="pengkinian-chip"
                        sx={{fontWeight: 700}}
                    />
                ) : (
                    <Stack alignItems="flex-end">
                        <Typography variant="body2" fontWeight={600}>-</Typography>
                        <Typography variant="caption" color="text.secondary">Status pengkinian gagal dimuat</Typography>
                    </Stack>
                )
            }
        </Stack>
    );
}
